module.exports = __webpack_public_path__ + "img/24px-checkmark.27c6de8f.svg";